exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-347261a6] {\n  background-color: #3b8686;\n}\n", ""]);

// exports
